/**
 * WHAT THE CABINET SAYS AT AN ADDRESS IT DOES NOT SERVE - the root route's `notFoundComponent`
 * (`src/router.tsx`). Register R-043 (lens finding U1-12).
 *
 * It used to be the router's bare "Not Found" text with no way back - a stale bookmark, a mistyped
 * link or an old e-mail's address was a dead end an author could leave only by typing an address.
 *
 * ★ IT NEEDS NO SESSION AND DRAWS NO SHELL, like the two doors beside it in this directory and like
 * the back office's own not-found (`web/admin/src/routes/not-found/NotFoundScreen.tsx`): an address
 * nothing answers has no gate to ask, and a sidebar of screens the reader may not be allowed into
 * would be a promise the page cannot make. So it offers the two ways on that work for everybody -
 * the cabinet (which sends a signed-out reader to sign in by itself, in a live build) and the
 * sign-in door. Both are `InAppAnchor`s: in place under the router, a full load anywhere else.
 *
 * ★ IN THE DOORS' CARD (the owner's live look at real cabinets, 2026-10-01 / design 15): the same
 * card over the stars as the sign-in door (`AuthShell`), the cabinet as its gold pill and the
 * sign-in door beside it - and no help line, so its two ways on stay the only links it offers.
 */
import { Group } from '@mantine/core';
import { AuthShell } from '../../features/auth/components/AuthShell';
import classes from '../../features/auth/components/auth-shell.module.css';
import { CABINET_HOME_PATH, SIGN_IN_PATH } from '../../features/auth/navigation';
import { InAppAnchor } from '../../features/shell/InAppAnchor';
import { useTranslation } from '../../i18n';

export function CabinetNotFound() {
  const { t } = useTranslation('auth');
  return (
    <AuthShell title={t('notFound.title')} standfirst={t('notFound.standfirst')} withHelp={false}>
      <Group gap="lg" justify="center">
        <InAppAnchor href={CABINET_HOME_PATH} className={classes.primaryLink}>
          {t('notFound.openCabinet')}
        </InAppAnchor>
        <InAppAnchor href={SIGN_IN_PATH} size="sm" fw={700}>
          {t('notFound.signIn')}
        </InAppAnchor>
      </Group>
    </AuthShell>
  );
}
